import React from "react";
import RegisterPage, { STATUS_BADGES, PRIORITY_BADGES, StatCard } from "../components/RegisterPage";
import { useHSE } from "../lib/store";

export default function RiskAssessment() {
  const { data, siteNames } = useHSE();
  const rows = data.riskAssessments || [];
  const critical = rows.filter((r) => r.residualRisk === "Critical" || r.initialRisk === "Critical").length;
  const approved = rows.filter((r) => r.approval === "Approved").length;

  const Top = (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
      <StatCard label="Total RA" value={rows.length} testid="ra-total" />
      <StatCard label="Approved" value={approved} tone="safe" testid="ra-approved" />
      <StatCard label="Critical Activities" value={critical} tone="critical" testid="ra-critical" />
      <StatCard label="Review Due" value={rows.filter((r) => new Date(r.reviewDate) < new Date()).length} tone="warning" testid="ra-review" />
    </div>
  );

  return (
    <RegisterPage
      title="Risk Assessment Register"
      subtitle="Hazard identification, hierarchy of controls, and residual risk — ISO 45001 §6.1.2"
      storeKey="riskAssessments"
      idPrefix="RA"
      topPanels={Top}
      columns={[
        { key: "id", label: "RA ID" },
        { key: "activity", label: "Activity" },
        { key: "site", label: "Site" },
        { key: "contractor", label: "Contractor" },
        { key: "hazard", label: "Hazard" },
        { key: "initialRisk", label: "Initial Risk" },
        { key: "residualRisk", label: "Residual Risk" },
        { key: "responsible", label: "Responsible" },
        { key: "reviewDate", label: "Review Date" },
        { key: "approval", label: "Approval" },
      ]}
      badgeMap={{ initialRisk: PRIORITY_BADGES, residualRisk: PRIORITY_BADGES, approval: STATUS_BADGES }}
      formFields={[
        { key: "id", label: "RA ID" },
        { key: "activity", label: "Activity" },
        { key: "site", label: "Site", type: "select", options: siteNames },
        { key: "contractor", label: "Contractor", type: "select", options: data.settings.contractors },
        { key: "hazard", label: "Hazard", type: "textarea", full: true },
        { key: "consequence", label: "Consequence" },
        { key: "existingControls", label: "Existing Controls", type: "textarea", full: true },
        { key: "initialRisk", label: "Initial Risk Rating", type: "select", options: ["Low", "Medium", "High", "Critical"] },
        { key: "additionalControls", label: "Additional Controls", type: "textarea", full: true },
        { key: "residualRisk", label: "Residual Risk Rating", type: "select", options: ["Low", "Medium", "High", "Critical"] },
        { key: "responsible", label: "Responsible Person" },
        { key: "reviewDate", label: "Review Date", type: "date" },
        { key: "approval", label: "Approval Status", type: "select", options: ["Draft", "Under Review", "Approved", "Rejected"] },
      ]}
    />
  );
}
